import { HttpParams } from '@angular/common/http';
import { Component, HostListener, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ITEM_TYPE, SearchParamAdv } from 'src/app/components/utils/advanced-search/advanced-search.component';
import { AdvSearch, AdvSearchProps } from 'src/app/components/utils/advanced-search/adv_search/adv-search';
import moment from 'moment';
import { CSVData, Doctype, FileProps, Invoice, Metadata, PaginatorInvoices, Workflow } from 'src/app/entities/invoices';
import { UTILS } from 'src/app/entities/Utils';
import { Etichetta } from 'src/app/entities/various';
import { InvoicesService } from 'src/app/services/invoices/invoices.service';
import { UserData, UserInfo } from 'src/app/services/login/login.service';
import { ModalServiceService } from 'src/app/services/modal-service/modal-service.service';
import { ToastService } from 'src/app/services/toast/toast.service';
//import { ngxCsv } from 'ngx-csv';
import {ExcelService} from 'src/app/services/excel/excel.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigProps, ConfigServiceService } from 'src/app/services/config-service/config-service.service';
import { FattureAttiveService } from 'src/app/services/fatture-attive/fatture-attive.service';

@Component({
  selector: 'app-estere-invoices',
  templateUrl: './estere-invoices.component.html',
  styleUrls: ['./estere-invoices.component.css']
})
export class EstereInvoicesComponent implements OnInit {

  @Input() userInfo :  UserData | undefined;
  @Input() structureDocType: Doctype | undefined;
  @Input() structureWorkflowStates: Workflow[] | undefined;

  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

    loading : boolean = false;
    // RICERCA AVANZATA
    advSearch: AdvSearch = new AdvSearch();
    customSearch : AdvSearchProps = {
      advanced_search: true,
      defaultItemClass: 'col-3',
      header: [
        { 
          id:"select_more",
          type: ITEM_TYPE.SELECT_MORE,
          label: "Dati fattura:",
          nameClass: "col-auto",
          select_more_values: []
        },
        {
          id: "state",
          type: ITEM_TYPE.MULTI_SELECT,
          label:"Stato",
          placeholder:"(Tutti)",
          nameClass: "col-3",
          multi_select_values: []
        },
        {
          id: "docCons",
          type: ITEM_TYPE.SELECT,
          label:"Documenti conservati",
          nameClass: "col-2",
          initValue:"_",
          select_values: [
            {key:"_", value: "(tutti)"},
            {key:"con", value: "Conservati"},
            {key:"noCons", value: "Non conservati"}
          ]
        },
        {
          id: "docTipoDoc",
          type: ITEM_TYPE.SELECT,
          label: "advancedsearch.tipoDoc",
          nameClass: "col-2 col-2_einv",
          initValue: "_",
          select_values: [
              { key: "_", value: "(tutti)" },
              { key: "TIPO:TD17", value: "TD17 - Integrazione/autofattura per acquisto servizi dall’estero" },
              { key: "TIPO:TD18", value: "TD18 - Integrazione per acquisto di beni intracomunitari" },
              { key: "TIPO:TD19", value: "TD19 - Integrazione/autofattura per acquisto di beni ex art.17 c.2 DPR 633/72" }
          ]
        }      
      ],
      body: [
        { 
          id:"filename",
          type: ITEM_TYPE.TEXT,
          label: "Filtro di ricerca:",
          placeholder:"Nome file",
          nameClass: "col-2"
        },
        {
          id: "dSCreate",
          type: ITEM_TYPE.DATE_PICKER,
          label:"Data creazione",
          placeholder:"Da",
          nameClass: "col-2"
        },
        {
          id: "dECreate",
          type: ITEM_TYPE.DATE_PICKER,
          placeholder:"a",
          nameClass: "col-2"
        },
        {
          id: "docCons",
          type: ITEM_TYPE.SELECT,
          label:"Documenti scaricati",
          nameClass: "col-2",
          initValue:"_",
          select_values: [
            {key:"_", value: "(tutti)"},
            {key:"s", value: "Scaricati"},
            {key:"l", value: "Letti"},
            {key:"ns", value: "Non scaricati"}
          ]
        },
        /*{
          id: "etichetta",
          type: ITEM_TYPE.SELECT,
          label:"Ricerca per etichetta",
          nameClass: "col-2",
          initValue:"_",
          select_values: []
        },*/
        {
          id: "btnClear",
          type: ITEM_TYPE.BUTTON,
          label:"Pulisci",
          nameClass: "col-auto",
          tooltip: "Ripristina la ricerca di default"
        }
      ]
    };


    notifications: Invoice[] = [];
    dataTable: Invoice[] | undefined;
    paginator: PaginatorInvoices | undefined;
    listStatusWorflow: Workflow[] = [];
    listStatus = [];
    labels: Etichetta[] = [];

    allSelected: boolean = false;

    doc_selection: string[] = [];
    file_selected: number = 0;
    max_selection: number = 100;

  anno: number;
  primaRicerca: boolean = false;

  configProps: ConfigProps | undefined;
  configDoc: Doctype | undefined;

  pages = [{key : 2},{key : 12}, {key : 25}, {key : 50}, {key : 100}, {key : 500}];
  params : HttpParams;

  constructor(public translate: TranslateService, private invoicesService : InvoicesService, private modalService : ModalServiceService,
    private toast : ToastService,private excelService:ExcelService, private router : Router, private route : ActivatedRoute, private configService: ConfigServiceService,
    private fatturaAttivaService: FattureAttiveService) { 
    this.innerWidth = window.innerWidth;

    this.anno = new Date().getFullYear();

    this.params = new HttpParams();
    this.params = this.params.append('endRow', 0);
    this.params = this.params.append('lastKeyVal', '');
    this.params = this.params.append('page', 1);
    this.params = this.params.append('pageDirection', 'FORWARD');
    this.params = this.params.append('pageSize', 12);
    this.params = this.params.append('pagination', true);
    this.params = this.params.append('paginationMode', 'SKIP');
    this.params = this.params.append('rows', 0);
    this.params = this.params.append('searchFilter', '{}');
    //this.params = this.params.append('searchFilter', '{"metadata":[{"name":"Data fattura","label":"Data fattura:","data_type":"d","input_type":"text","options_list":"","value":["' + this.anno + '-01-01T00:00:00.000Z","' + this.anno + '-12-31T23:00:00.000Z"]}]}');
    this.params = this.params.append('sortDir', 'DESC');
    this.params = this.params.append('sortKey', 'date_created');
    this.params = this.params.append('startRow', 0);
    this.params = this.params.append('totalPages', -1);
    this.params = this.params.append('totalRows', 0);
  }



  ngOnChanges(changes: SimpleChanges): void {
    let check : boolean = false;
    if(changes.structureDocType){
      this.structureDocType = changes.structureDocType.currentValue;
      check = true;
    }
    if(changes.structureWorkflowStates){
      this.structureWorkflowStates = changes.structureWorkflowStates.currentValue;
      check = true;
    }
    if(check){
      this.createCloneCustomSearch();
    }
  }

  async ngOnInit(): Promise<void> {
    //this.labels = await (await this.invoicesService.getLabels(this.userInfo!.dms_user_id)).data;
    this.configProps = new UTILS().deepCopy(await this.configService.getJSON());
    this.configDoc = new UTILS().deepCopy(await this.configService.getDocTypeAttiva());

    this.createCloneCustomSearch();

    /*let responsePassiveWorkflowStates = await this.invoicesService.getWorkflowStates(this.userInfo!.dms_user_id);
    if (responsePassiveWorkflowStates.success) {
      this.structureWorkflowStates = responsePassiveWorkflowStates.data;
    }

    const searchFilter = {
      date_created: {
          "0": `${this.anno}-01-01T00:00:00.000Z`,
          "1": `${this.anno}-12-31T23:59:59.999Z`
      }
    };

    const searchFilterStr = JSON.stringify(searchFilter);

    this.params = this.params.delete('searchFilter');
    this.params = this.params.append('searchFilter', searchFilterStr);

    (this.customSearch.body?.forEach(elem => {
                
        if (elem.id == "dSCreate") {
            elem.value = { year: this.anno, month: 8, day: 1 };
        }
        if (elem.id == "dECreate") {
            elem.value = { year: this.anno, month: 8, day: 31 };
        }
    }));*/

    this.structureDocType = this.configDoc as Doctype;
    this.structureDocType.metadata.sort(
        (a: Metadata, b: Metadata) => {
            const order = ['denominazione', 'datafattura', 'numerofattura'];
            const indexA = order.indexOf(((a.name).toLowerCase()).replace(" ", ""));
            const indexB = order.indexOf(((b.name).toLowerCase()).replace(" ", ""));
            if (indexA !== -1 && indexB !== -1) {
                return indexA - indexB;
            } else if (indexA !== -1) {
                return -1;
            } else if (indexB !== -1) {
                return 1;
            } else {
                return 0;
            }
        }
    );
    console.log(this.structureDocType);

    const searchFilter = {
        date_created: {
            "0": `${this.anno}-01-01T00:00:00.000Z`,
            "1": `${this.anno}-12-31T23:59:59.999Z`
        }
    };

    const searchFilterStr = JSON.stringify(searchFilter);

    this.params = this.params.delete('searchFilter');
    this.params = this.params.append('searchFilter', searchFilterStr);

    /*let responsePassiveDocType = await this.invoicesService.getDoctype(this.userInfo!.dms_user_id);
    if (responsePassiveDocType.success){


      this.structureDocType = responsePassiveDocType.data;

      // cerco la data fattura
      this.structureDocType!.metadata.forEach(meta => {
        if ((meta.name.toLowerCase()).replace(" ", "") == "datafattura") {
          
        
         
        //this.params = this.params.delete('searchFilter');
        //this.params = this.params.append('searchFilter', searchFilterStr);
        //this.params = this.params.append('searchFilter', '{}');
            //this.params = this.params.delete('searchFilter');
            //this.params = this.params.append('searchFilter', '{"metadata":[{"name":"' + meta.name + '","label":"' + meta.label + '","data_type":"d","input_type":"text","options_list":"","value":["' + this.anno + '-01-01T00:00:00.000Z","' + this.anno + '-12-31T23:00:00.000Z"]}]}');
        }
      });
    }*/

    this.primaRicerca = true;
    await this.getDataTable();
  }

  createCloneCustomSearch(){
    if(this.structureWorkflowStates && this.structureWorkflowStates.length > 0){
      this.customSearch.header.filter(i => i.id == "state")[0].multi_select_values = []
      this.structureWorkflowStates.forEach(e => {
        this.customSearch.header.filter(i => i.id == "state")[0].multi_select_values!.push({key: e.code, value: e.name})
      });
    }
    if(this.labels && this.labels.length>0) {
      /* @ts-ignore */
      this.customSearch.body?.filter(i=> i.id=='etichetta')[0].select_values!= [];
      this.labels.forEach(l => {
        this.customSearch.body?.filter(i=> i.id=='etichetta')[0]
                              .select_values!.push( {key: "colore:" + l.style + ':' + l.etichetta.replace(/ /g, '-'), value : l.etichetta })

      })
    }
    if(this.structureDocType){
      this.customSearch.header.filter(i => i.id == "select_more")[0].select_more_values = []
      this.structureDocType.metadata.forEach(m => {
        switch(m.input_type){
          case "text":
            switch(m.data_type){
              case "t":
                this.customSearch.header.filter(i => i.id == "select_more")[0].select_more_values!.push({
                  key: m.name,
                  value: m.label,
                  body: [
                    {id:m.name, type: ITEM_TYPE.TEXT, placeholder: m.label},
                    {id:"beetween", type: ITEM_TYPE.CHECKBOX, tooltip:"Cerca nel mezzo"}
                  ]
                });
              break;
              case "d":
                this.customSearch.header.filter(i => i.id == "select_more")[0].select_more_values!.push({
                  key: m.name,
                  value: m.label,
                  body: [
                    {id:'dS', type: ITEM_TYPE.DATE_PICKER, placeholder: 'Da'},
                    {id:'dE', type: ITEM_TYPE.DATE_PICKER, placeholder: 'a'},
                  ]
                });
              break;
              case "i":
              case "n":
                this.customSearch.header.filter(i => i.id == "select_more")[0].select_more_values!.push({
                  key: m.name,
                  value: m.label,
                  body: [
                    {id:m.name, type: ITEM_TYPE.NUMBER, placeholder: m.label},
                    {id:"beetween", type: ITEM_TYPE.CHECKBOX, tooltip:"Cerca nel mezzo"}
                  ]
                });
              break;
            }
            break;
        }
      });
      if(this.customSearch.header.filter(i => i.id == "select_more")[0].select_more_values!.length > 0){
        this.customSearch.header.filter(i => i.id == "select_more")[0].initValue = this.customSearch.header.filter(i => i.id == "select_more")[0].select_more_values![0].key;
      }
    }
    this.advSearch.setAdvSearch(this.customSearch);
  }


  async setPage(newPage:number){
    this.loading=true;
    if(this.params.get('page') != null){
        this.params = this.params.set('page', newPage);
        await this.getDataTable();
    }
    this.loading=false;
  }
  async next(){
    if(this.params.get('page') != null){
      let val : number = +this.params.get('page')! + 1;
      this.params = this.params.set('page', val);
      await this.getDataTable();
    }
  }


  async prev(){
    if(this.params.get('page') != null){
      let val : number = +this.params.get('page')! - 1;
      this.params = this.params.set('page', val);
      await this.getDataTable();
    }
  }


  getType(tags : {text : string}[]){
    let str = '';
    tags.forEach(e => {
      if (e.text.includes('TIPO:')) {
        str = e.text.split('TIPO:')[1];
      };
    });
    return str;
  }

  goToEditor(invoiceId : string) {
    localStorage.setItem("einvoice_modify_doc", invoiceId);
    this.router.navigate(['edit'], {relativeTo: this.route});
  }

    setSelected() {
        this.dataTable?.forEach(d => d.selected = this.allSelected);
        this.updateSelectedDocs();
    }

    checkAllSelected() {
        this.allSelected = this.dataTable?.filter(d => d.selected).length == this.dataTable?.length;
        this.updateSelectedDocs();
    }

  async sort(key: string){
    // this.params =this.params.delete('sortKey');
    // this.params =this.params.delete('sortDir');
    // this.params =this.params.append('sortKey', key);
    // this.params =this.params.append('sortDir', this.sortUtils.getSortDir(key));
    await this.getDataTable();
  }


  async getDataTable(){
    this.dataTable = undefined;
    //let jsonTag = (JSON.parse('{"tags":[{"text":"TIPO:TD17"},{"text":"TIPO:TD18"},{"text":"TIPO:TD19"}]}'));
    let jsonEstera = (JSON.parse('{"estera":1}'));
    let filtroRicerca = (this.params.get('searchFilter'));
    let joinfiltro = {};
    /*if (filtroRicerca !== null && filtroRicerca !== "") {
      let jsonfiltro = (JSON.parse(filtroRicerca));
      if (jsonfiltro.hasOwnProperty('tags')) {
        for (let val in jsonfiltro) {
          if (val == "tags") {  
            jsonTag.tags.push(jsonfiltro[val][0]);
            joinfiltro = {...jsonfiltro, ...jsonTag};
          }
          
        }
      } else {
        joinfiltro = {...jsonfiltro, ...jsonTag};
      }
      
      this.params = this.params.set('searchFilter', JSON.stringify(joinfiltro));
    } else {
      this.params = this.params.set('searchFilter', JSON.stringify(jsonTag));
    }*/
    if (filtroRicerca !== null && filtroRicerca !== "") {
      let jsonfiltro = (JSON.parse(filtroRicerca));
      joinfiltro = {...jsonfiltro, ...jsonEstera};
      this.params = this.params.set('searchFilter', JSON.stringify(joinfiltro));
    } else {
      this.params = this.params.set('searchFilter', JSON.stringify(jsonEstera));
    }

    let response = await this.fatturaAttivaService.findInvoice(this.userInfo!.user_id, this.params);
    if(response.success){
      this.paginator = response.data as PaginatorInvoices;
      this.dataTable = this.paginator.data as Invoice[];
    } else {
      this.dataTable=[];
      this.toast.openToast(response.msg, "error");
      this.loading = false;
    }
  }

  async changePageSize (pageSize: number) {
    this.params= this.params.delete('pageSize');
    this.params= this.params.append('pageSize', pageSize);
    await this.getDataTable();
  }


    formatDateISOString(value: any): string {
        let format: string = '';
        if (value != undefined && value != '') {
            let date = new Date();
            date.setFullYear(value.year, value.month - 1, value.day);
            format = date.toISOString();
        }
        return format;
    }

    updateSelectedDocs() {
        this.dataTable?.forEach(d => {
            if (d.selected) {
                if (this.doc_selection.indexOf(d.id) == -1) {
                    this.doc_selection.push(d.id);
                }
            } else {
                let p = this.doc_selection.indexOf(d.id);

                if (p != -1) {
                    this.doc_selection.splice(p, 1);
                }
            }
        });

        if (this.doc_selection.length > this.max_selection) {
            this.doc_selection.splice(this.max_selection);

            this.toast.openToast("Attenzione, il limite massimo di documenti selezionabili è " + this.max_selection, 'warning');
            this.getDataTable();
        }

        this.file_selected = this.doc_selection.length;
    }

    async deselectAll() {
        let label: string = await new UTILS().getTranslateTitle(this.translate, "modal.labels.confirm");
        //let message: string = await new UTILS().getTranslateTitle(this.translate, "modal.messages.mantieni_data_numero");
        let message: string = "Anullare la selezione?";
        let check = await this.modalService.openConfirmBozza(label, message);
        if (check) {
            this.doc_selection = [];

            this.dataTable?.forEach(d => {
                d.selected = false;
            });

            this.updateSelectedDocs();
            this.allSelected = false;
            this.getDataTable();
        }
    }


  /**
   * Ricerca avanzata
   * @param event 
   */
   async searchParams(event : SearchParamAdv){
    this.dataTable = undefined;
    // METADATI
    let objRequest : any = {};
    try {
      let metadata = new UTILS().deepCopy(this.structureDocType!.metadata.filter(m => m.name == event.header.filter(h => h.id == "select_more")[0].value)[0]);
      if(metadata.data_type != "d"){
        if(event.header.filter(h => h.id == "select_more")[0].child.length > 0){
          metadata.value = event.header.filter(h => h.id == "select_more")[0].child.filter(c => c.id == event.header.filter(h => h.id == "select_more")[0].value)[0].value;
          if(event.header.filter(h => h.id == "select_more")[0].child.filter(i => i.id == "beetween").length > 0 && event.header.filter(h => h.id == "select_more")[0].child.filter(i => i.id == "beetween")[0].value){
            metadata.value ="*" + metadata.value + "*";
            metadata["search_type"]="LIKE"
          }
        }
      } else {
        metadata.value = []
        if(event.header.filter(h => h.id == "select_more")[0].child.filter(i => i.id == "dS").length > 0){
          let ds = event.header.filter(h => h.id == "select_more")[0].child.filter(i => i.id == "dS")[0].value;
          metadata.value.push(ds);
        }
        if(event.header.filter(h => h.id == "select_more")[0].child.filter(i => i.id == "dE").length > 0){
          let de = event.header.filter(h => h.id == "select_more")[0].child.filter(i => i.id == "dE")[0].value;
          metadata.value.push(de);
        }
      }
      objRequest["metadata"] = [metadata];
    } catch (error) {}
    // WORKFLOW_ID + WORKFLOW STATE
    if(event.header.filter(h => h.id == "state").length > 0){
      objRequest["workflow_id"] = this.structureDocType!.workflow_id;
      objRequest["workflow_state_code"] = event.header.filter(h => h.id == "state")[0].value.value;
    } else {
      objRequest["workflow_id"] = "";
      objRequest["workflow_state_code"] = [""];
    }
    // CONSERVATI
    if(event.header.filter(h => h.id == "docCons").length > 0 && event.header.filter(h => h.id == "docCons")[0].value != "_"){
      objRequest["conservato"] = event.header.filter(h => h.id == "docCons")[0].value == "con" ? 1 : 0;
    }
    // TAGS - Etichette
    if(event.body.filter(h => h.id == "etichetta").length > 0 && event.body.filter(h => h.id == "etichetta")[0].value != "colore::Tutti"){
      objRequest["tags"] = [{text: event.body.filter(h => h.id == "etichetta")[0].value}];
    }
    // TITLE - Filename
    if(event.body.filter(h => h.id == "filename").length > 0){
      objRequest["file_name"] = event.body.filter(h => h.id == "filename")[0].value;
    }
    // date_created - data creazione
    if(event.body.filter(h => h.id == "dSCreate").length > 0){
      if(!objRequest["date_created"]){
        objRequest["date_created"] = {};
      }
      objRequest["date_created"]["0"] = event.body.filter(h => h.id == "dSCreate")[0].value;
    }
    if(event.body.filter(h => h.id == "dECreate").length > 0){
      if(!objRequest["date_created"]){
        objRequest["date_created"] = {};
      }
      objRequest["date_created"]["1"] = event.body.filter(h => h.id == "dECreate")[0].value;
    }
    // download
    if(event.body.filter(h => h.id == "docCons").length > 0 && event.body.filter(h => h.id == "docCons")[0].value != "_"){
      objRequest["download"] = event.body.filter(h => h.id == "docCons")[0].value == "l" ? 1 : event.body.filter(h => h.id == "docCons")[0].value == "s" ? 2 : 0;
    }
    this.params = this.params.delete('searchFilter');
    this.params = this.params.append('searchFilter', JSON.stringify(objRequest));
    this.primaRicerca = false;
    await this.getDataTable();
  }

  async callButton(event: {id: string, body: SearchParamAdv}){
    if(event.id == "btnClear"){
      this.dataTable = undefined;
      this.advSearch.setAdvSearch(this.customSearch);
      this.params = new HttpParams();
      this.params = this.params.append('endRow', 0);
      this.params = this.params.append('lastKeyVal', '');
      this.params = this.params.append('page', 1);
      this.params = this.params.append('pageDirection', 'FORWARD');
      this.params = this.params.append('pageSize', 12);
      this.params = this.params.append('pagination', true);
      this.params = this.params.append('paginationMode', 'SKIP');
      this.params = this.params.append('rows', 0);
      this.params = this.params.append('searchFilter', '');
      this.params = this.params.append('sortDir', 'DESC');
      this.params = this.params.append('sortKey', 'date_created');
      this.params = this.params.append('startRow', 0);
      this.params = this.params.append('totalPages', -1);
      this.params = this.params.append('totalRows', 0);

      const searchFilter = {
        date_created: {
            "0": `${this.anno}-01-01T00:00:00.000Z`,
            "1": `${this.anno}-12-31T23:59:59.999Z`
        }
      };
  
      const searchFilterStr = JSON.stringify(searchFilter);
  
      this.params = this.params.delete('searchFilter');
      this.params = this.params.append('searchFilter', searchFilterStr);
  
      (this.customSearch.body?.forEach(elem => {
                  
          if (elem.id == "dSCreate") {
              elem.value = { year: this.anno, month: 8, day: 1 };
          }
          if (elem.id == "dECreate") {
              elem.value = { year: this.anno, month: 8, day: 31 };
          }
      }));

      this.primaRicerca = true;
      await this.getDataTable();
    }
  }


  async openPreview(docId : string, fileName : string, indice: number) {
    let docData : string = await (await this.fatturaAttivaService.getDocument(docId, this.userInfo!.user_id)).data;
    let fileUrl = new UTILS().getFileUrl(docData);
    this.modalService.openPreview(fileUrl, fileName);
    this.dataTable![indice].download = 1;
  }

  async downloadFile(option : string, docId : string, indice: number) {
    let path : string = '';
    switch (option) {
      case 'file' : {
        path = '/download';
        break;
      }
      case 'xml' : {
        path = '/download_no_signature'
        break;
      }
      case 'allegati' : {
        path = '/attachment'
        break;
      }
    }
    let response = await this.fatturaAttivaService.downloadInvoiceFiles(this.userInfo!.user_id, docId, path);
    if(response.success){
      let data = (response.data as FileProps);
      new UTILS().downloadFile(data.mime_type, data.content, data.file_name);
     
      this.toast.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.operation.success"), "success");
      switch(option) {
        case 'file':
        case 'xml':
          this.dataTable![indice].download = 2;
          break;
        case 'allegati':
          // non si deve ricaricare
          break;
      }
    } else {
      
      this.toast.openToast(response.msg, "error");
    }
  }

  async showPreviewMinisteriale(invoiceId : string, fileName : string, indice: number) {
    let docData : string = await (await this.fatturaAttivaService.getPreviewMinist(invoiceId, this.userInfo!.user_id)).data.data;
    let fileUrl = new UTILS().getFileUrl(docData);
    this.modalService.openPreview(fileUrl, fileName);
    this.dataTable![indice].download = 1;
  }

  async getNotifications(list : string[]) {
    this.notifications = await (await this.invoicesService.getNotifications(list, this.userInfo!.user_id)).data;
  }

  async openNotification(invoiceId:string, notificationId:string, fileName : string) {
    let docData : string = await (await this.invoicesService.getNotificationFile(invoiceId, notificationId, this.userInfo!.user_id)).data.data;
    let fileUrl = new UTILS().getFileUrl(docData);
    this.modalService.openPreview(fileUrl, fileName);
  }

    async downloadAll(filetype: string) {
        let setPageSize: number = this.invoicesService.setPageSize;
        let label: string = await new UTILS().getTranslateTitle(this.translate, "modal.labels.confirm");
        let message: string = await new UTILS().getTranslateTitle(this.translate, "invoices.modal.downloadAllFiles");

        await new UTILS().getTranslateTitle(this.translate, "modal.labels.confirm");

        let check = await this.modalService.openConfirm(label, message);
        if (check) {
            this.loading = true;

            let pageSize: string | null = this.params.get('pageSize');
            let psize: number = 0;

            if (pageSize != null) {
                psize = parseInt(pageSize);
            }

            this.params = this.params.delete('pageSize');
            this.params = this.params.append('pageSize', setPageSize);

            let jsonEstera = (JSON.parse('{"estera":true}'));
            let filtroRicerca = (this.params.get('searchFilter'));
            let joinfiltro = {};

            if (filtroRicerca !== null && filtroRicerca !== "") {
                let jsonfiltro = (JSON.parse(filtroRicerca));
                joinfiltro = { ...jsonfiltro, ...jsonEstera };
                this.params = this.params.set('searchFilter', JSON.stringify(joinfiltro));
            } else {
                this.params = this.params.set('searchFilter', JSON.stringify(jsonEstera));
            }

            let response = await this.invoicesService.findAllInvoices(this.userInfo!.user_id, filetype, this.params);
            if (response.success) {
                this.toast.openToast(await new UTILS().getTranslateTitle(this.translate, "toast.operation.success"), "success");
            } else {
                if (response.data == null) {
                    this.toast.openToast(response.error, "warning");
                } else {
                    let label = await new UTILS().getTranslateTitle(this.translate, "modal.labels.confirm");
                    let message = response.error;
                    let check = await this.modalService.openConfirmBozza(label, message);
                    if (check) {
                        let res = await this.invoicesService.deleteTask(this.userInfo!.user_id, response.data);
                        if (res.success) {
                            this.toast.openToast(await new UTILS().getTranslateTitle(this.translate, "toast.operation.success"), "success");
                        }
                    }
                }
            }

            this.params = this.params.delete('pageSize');
            this.params = this.params.append('pageSize', psize);

            this.loading = false;
        }
    }

    async downloadSelected() {
        let document_ids: string[] = [];
        this.dataTable!.filter(i => i.selected).forEach(i => document_ids.push(i.id));
        if (document_ids.length > 0) {
            this.loading = true;
            let response = await this.fatturaAttivaService.downloadZip(this.userInfo!.user_id, document_ids);
            if (response.success) {
                let data = (response.data as FileProps);
                new UTILS().downloadFile(data.mime_type, data.content, data.file_name);
                this.toast.openToast(await new UTILS().getTranslateTitle(this.translate, "toast.operation.success"), "success");
                this.getDataTable();
            } else {

                this.toast.openToast(await new UTILS().getTranslateTitle(this.translate, "toast.getDoc.error"), "error");
            }
        } else {
            this.toast.openToast(await new UTILS().getTranslateTitle(this.translate, "toast.getDoc.warning"), "warning");
        }
        this.loading = false;
    }

  stringToDate(value: string, format: string){
    if (value == '' || typeof(value) == 'undefined') {
      return "";
    } else {
      return moment(value).format(format);
    }
    //return (value !== undefined || value !== '') ? moment(value).format(format) : '';
  }

  async downloadCSV() {
    let data : CSVData[] = [];
 /*   data.push({
      Filename : 'Filename',
      Tipo : 'Tipo',
      Numero : 'Numero',
      Data : 'Data',
      Destinatario : 'Denominazione',
      Importo : 'Importo',
      IdentificativoSdi : 'Identificativo Sdi',
      Stato : 'Stato'
    })*/
    this.dataTable!.filter(i => i.selected).forEach(i => {
      let row : CSVData = {
        Filename : i.file_name,
        Tipo : this.getType(i.tags),
        Numero : i['Numero fattura'],
        Data : this.stringToDate(i.date_created, "DD/MM/YYYY"),
        Destinatario : i.denominazione,
        Importo : i.Importo + ' €',
        IdentificativoSdi : i.IdentificativoSdI,
        Stato : i.workflow_state
      }
      data.push(row);
    });
    if(data.length > 0) {
      //new ngxCsv(data, 'export');
      this.excelService.exportAsExcelFile(data, 'export_' + Date.now());
    } else {
      this.toast.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.getDoc.warning"), "warning");
    }
    

  }

  async setDownload(downloadCode : number) {
    let document_ids :string[]= [];
    this.dataTable!.filter(i => i.selected).forEach(i=> document_ids.push(i.id));
    if(document_ids.length > 0) {
      this.loading=true;
      let response = await this.invoicesService.setDownload(this.userInfo!.user_id, document_ids, downloadCode);
    if(response.success) {
      this.toast.openToast(response.msg, 'success');
      this.getDataTable();
    } else {
      this.toast.openToast(response.msg, 'error')
    }
    } else {
      this.toast.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.getDoc.warning"), "warning");
    }
    this.loading=false;
  }

  async assignTag(label : Etichetta) {
    let document_ids :string[]= [];
    this.dataTable!.filter(i => i.selected).forEach(i=> document_ids.push(i.id));
    let tag = 'colore:' + label.style + ':' + label.etichetta;
    if(document_ids.length > 0) {
      let response = await this.invoicesService.assignTag(this.userInfo!.user_id, document_ids, tag);
    if(response.success) {
      this.toast.openToast(response.msg, 'success');
      this.getDataTable();
    } else {
      this.toast.openToast(response.msg, 'error')
    }
    } else {
      this.toast.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.getDoc.warning"), "warning");
    }
  }
  
  async downloadPDF(option : string){
    let document_ids :string[]= [];
    this.dataTable!.filter(i => i.selected).forEach(i=> document_ids.push(i.id));
    if(document_ids.length > 0){
      this.loading=true;
      let response = await this.fatturaAttivaService.downloadPDF(this.userInfo!.user_id,document_ids, option);
    if(response.success){
      let data = (response.data as FileProps);
      new UTILS().downloadFile(data.mime_type, data.content, data.file_name);
      this.toast.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.operation.success"), "success");
    } else {
      
      this.toast.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.getDoc.error"), "error");
    }
    } else {
      this.toast.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.getDoc.warning"), "warning");
    }
    this.loading=false;
  }

  getTag(tags : {text : string}[]) {
    let str : string[] = [];
    tags.forEach(e => {
      if (e.text.includes('colore:')) {
        str = e.text.split(':').splice(1,2);
        
      } 
    });
    return str;
  }

  getImponibile(tags : {text : string}[]){
    let str = '';
    tags.forEach(e => {
      if (e.text.includes('IMPONIBILE:')) {
        str = e.text.split('IMPONIBILE:')[1];
      };
    });
    return str;
  }

  getImposta(tags : {text : string}[]){
    let str = '';
    tags.forEach(e => {
      if (e.text.includes('IMPOSTA:')) {
        str = e.text.split('IMPOSTA:')[1];
      };
    });
    return str;
  }

  getAllegati(tags : {text : string}[]){
    let str = false;
    tags.forEach(e => {
      if (e.text.includes('ALLEGATI:')) {
        str = true;
      };
    });
    return str;
  }

    getTooltip(invoice : Invoice) :string {
    let tooltip : string = '';
    switch(invoice.download) {
      case 0 : {
       tooltip ='invoices.table.tooltips.notDownloaded';
        break;
      };
      case 1 : {
        tooltip = 'invoices.table.tooltips.read';
        break;
      };
      case 2: {
        
        tooltip = 'invoices.table.tooltips.downloaded';
        break;
      }
    }
    
    return tooltip;

  }

  public formatNumber(value :string){
    return Number(value).toFixed(2);
   }
   

   async cancellaBozza(invoiceId: string) {
    let response = await this.invoicesService.deleteDraft(this.userInfo!.user_id, invoiceId);
    if (response.success) {
        this.toast.openToast("Cancellazione fattura effettuata con successo", 'success');
        this.getDataTable();
    } else {
        this.toast.openToast(response.msg, 'error')
    }

}

}
